"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiDef_PermissionUser = void 0;
const thunderstorm_1 = require("@nu-art/thunderstorm");
exports.ApiDef_PermissionUser = {
    vv1: { assignPermissions: { method: thunderstorm_1.HttpMethod.POST, path: '/pah/permissions/assign/app-permissions' } }
};
